import { useLocation, useNavigate } from 'react-router-dom';

export function useGoBack() {
  const navigate = useNavigate();
  const location = useLocation();

  const goBack = () => {
    const segments = location.pathname.split('/').filter(Boolean);
    if (segments.length === 0) {
      navigate('/');
      return;
    }
    segments.pop();
    navigate(`/${segments.join('/')}`);
  };

  return { goBack };
}
